import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import { environment } from './environments/environment';

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));

if (environment.production) {
  console.log = () => {};
  console.warn = () => {};
}
